import { getAnalyticsWebClientPromise } from '@atlassian/jira-product-analytics-web-client-async';
import type {
	Match,
	Route,
	MatchedRoute,
} from '@atlassian/react-resource-router/src/common/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouterState } from '@atlassian/react-resource-router/src/controllers/router-store/types.tsx';

let matchedRoute: MatchedRoute | null = null;

export const setMatchedRoute = (route?: Route | null, match?: Match) => {
	if (route && match) {
		matchedRoute = { route, match };
	}
};

export const getMatchedRoute = () => matchedRoute;

export const getRouteName = () => matchedRoute?.route.name ?? 'unknown';

export const getUserLocation = () => `${matchedRoute?.route.group ?? 'unknown'}:${getRouteName()}`;

export const getUfoName = () => {
	if (fg('jfp-magma-report-bifrost-route-attributes')) {
		return matchedRoute?.route?.ufoName ?? 'unknown';
	}

	return undefined;
};

export const getBifrostGroup = () => {
	if (fg('jfp-magma-report-bifrost-route-attributes')) {
		return matchedRoute?.route?.bifrost?.bifrostGroup ?? 'none';
	}

	return undefined;
};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { RouterState };

let previousRouterState: RouterState | null = null;
let previousSubProduct = '';

export const setPreviousRouterState = (state: RouterState | null) => {
	previousRouterState = state;
};

export const getPreviousRouterState = () => previousRouterState;

export const setPreviousSubProduct = (subProduct: string | null) => {
	previousSubProduct = subProduct || '';
};

export const getPreviousSubProduct = () => previousSubProduct;

export const setSubProduct = (subproduct: string | null) => {
	if (subproduct === null) {
		return;
	}

	if (previousSubProduct !== subproduct) {
		setPreviousSubProduct(subproduct);
	}

	getAnalyticsWebClientPromise().then((client) => {
		client.setSubProduct(subproduct);
	});
};

/**
 * @deprecated use generatePath(route.path) from '@atlassian/react-resource-router' instead. Use getLinkPropsFromRoute instead of getLinkProps.
 *
 * Convert /jira/software/c/projects/:projectKey/boards/:boardId to /jira/software/c/projects/ABC/boards/100.
 * Allows to reuse route.path in code that needs a real url path.
 */
export const routeToUrlPath = (
	route: Route,
	pathParamValues: Record<string, string | number> = {},
) => {
	let result = route.path;
	Object.keys(pathParamValues).forEach((pathParamKey) => {
		result = result.replaceAll(`:${pathParamKey}`, pathParamValues[pathParamKey].toString());
	});

	if (result.indexOf('/:') !== -1) {
		// throwing error to fail early, as the path with not all :param replaced will not be usable, and will elad to other errors down hte line.
		throw new Error(
			`routePathToUrlPath: values for some path params have not been provided: ${result}`,
		);
	}

	return result;
};
